const WEEKDAY = ['日', '月', '火', '水', '木', '金', '土']

/** Date → "6/18(木)" */
export function formatDate(d: Date): string {
  return `${d.getMonth() + 1}/${d.getDate()}(${WEEKDAY[d.getDay()]})`
}

/** Date → "2026-06-18"（選択管理キー）*/
export function isoKey(d: Date): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

/** "2026-06-18" → Date（ローカル0時）*/
export function parseKey(key: string): Date {
  const [y, m, d] = key.split('-').map(Number)
  return new Date(y, m - 1, d)
}

export const WEEKDAY_HEADERS = WEEKDAY

/** 指定月のカレンダー格子（週ごとの配列、空きセルは null）*/
export function monthGrid(year: number, month0: number): (Date | null)[][] {
  const startDay = new Date(year, month0, 1).getDay()
  const daysInMonth = new Date(year, month0 + 1, 0).getDate()
  const cells: (Date | null)[] = []
  for (let i = 0; i < startDay; i++) cells.push(null)
  for (let d = 1; d <= daysInMonth; d++) cells.push(new Date(year, month0, d))
  while (cells.length % 7 !== 0) cells.push(null)
  const weeks: (Date | null)[][] = []
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7))
  return weeks
}
